<template>
  <EhouseDoubleCalculatingDetail />
</template>

<script>
import EhouseDoubleCalculatingDetail from "@/components/Calculatings/EhouseDoubleCalculating/Detail.vue";
export default {
  components: { EhouseDoubleCalculatingDetail },
};
</script>

<style></style>
